import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["minimumWordCount", "answerRequired"]

  connect() {
    this.defaultMinimumWordCount = parseInt(this.minimumWordCountTarget.value) || 0
    if (!this.answerRequiredTarget.checked) {
      this.minimumWordCountTarget.value = 0
    }
  }

  toggleAnswerRequired() {
    const isRequired = this.answerRequiredTarget.checked
    if (!isRequired) {
      this.minimumWordCountTarget.value = 0
    } else {
      this.minimumWordCountTarget.value = this.defaultMinimumWordCount
    }
  }
} 